import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useReview } from '../../context/ReviewContext';

// Product List Card - แสดงแบบแนวยาวสำหรับมือถือ (ประหยัดพื้นที่)
const ProductListCard = ({ product, onAddToCart, showAddToCart = true, userStoreId = null }) => {
  const { t } = useTranslation();
  const { getProductReviewStats } = useReview();
  const [reviewStats, setReviewStats] = useState({ averageRating: 0, totalReviews: 0 });
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    const loadReviewStats = async () => {
      if (product?.id) {
        try {
          const stats = await getProductReviewStats(product.id);
          setReviewStats(stats);
        } catch (error) {
          console.error('Error loading product review stats:', error);
        }
      }
    };
    loadReviewStats();
  }, [product?.id, getProductReviewStats]);

  const handleAddToCart = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (onAddToCart) {
      onAddToCart(product);
    }
  };

  // สร้าง thumbnail URL ที่บีบอัด (ใช้ query parameter สำหรับ compression)
  const getThumbnailUrl = (url) => {
    if (!url) return null;
    // ถ้าเป็น Firebase Storage URL สามารถเพิ่ม query parameter สำหรับ resize
    if (url.includes('firebasestorage.googleapis.com')) {
      return `${url}?alt=media&token=thumbnail`;
    }
    // สำหรับ URL อื่นๆ ใช้ image CDN หรือ return เดิม
    return url;
  };

  return (
    <Link to={`/marketplace/products/${product.id}`} className="block">
      <div className="bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow duration-300 border border-gray-100">
        <div className="flex gap-3 p-3">
          {/* รูปภาพสินค้า - แสดงเล็กๆ แบบบีบอัด */}
          <div className="relative w-20 h-20 md:w-24 md:h-24 flex-shrink-0 bg-gradient-to-br from-green-400 to-green-600 rounded-lg overflow-hidden">
            {product.images && product.images.length > 0 && !imageError ? (
              <>
                <img
                  src={getThumbnailUrl(product.images[0])}
                  alt={product.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                  onError={() => setImageError(true)}
                  style={{ imageRendering: 'auto' }}
                />
                {/* Indicator ว่ามีรูปหลายรูป */}
                {product.images.length > 1 && (
                  <div className="absolute bottom-1 right-1 bg-black bg-opacity-50 text-white px-1 py-0.5 rounded text-xs">
                    📷 {product.images.length}
                  </div>
                )}
              </>
            ) : (
              <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-green-400 to-green-600 relative overflow-hidden">
                <img 
                  src="/logo.png" 
                  alt="CannaTrade Logo" 
                  className="w-12 h-12 md:w-16 md:h-16 object-contain opacity-80"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentElement.innerHTML = '<div class="text-white text-xl">🌿</div>';
                  }}
                />
              </div>
            )}
            
            {/* Discount Badge */}
            {product.discount && product.discount > 0 && (
              <div className="absolute top-1 left-1 bg-red-500 text-white px-1 py-0.5 rounded text-xs font-bold">
                -{product.discount}%
              </div>
            )}
            
            {/* Badge สถานะ */}
            {product.status === 'auction' && (
              <div className="absolute bottom-1 left-1 bg-yellow-500 text-white px-1 py-0.5 rounded text-xs">
                🔨
              </div>
            )}
            {product.status === 'sold_out' && (
              <div className="absolute bottom-1 left-1 bg-red-500 text-white px-1 py-0.5 rounded text-xs">
                {t('marketplace.outOfStock')}
              </div>
            )}
          </div>

          {/* ข้อมูลสินค้า */}
          <div className="flex-1 min-w-0">
            <h3 className="text-sm md:text-base font-medium text-gray-800 mb-1 line-clamp-2 leading-tight">
              {product.name}
            </h3>
            
            {/* ราคา */}
            <div className="mb-1">
              <p className="text-base md:text-lg font-bold text-red-500">
                ฿{product.price?.toLocaleString()}
              </p>
              {product.originalPrice && product.originalPrice > product.price && (
                <p className="text-xs text-gray-400 line-through">
                  ฿{product.originalPrice.toLocaleString()}
                </p>
              )}
            </div>
            
            {/* Rating และ Reviews */}
            {reviewStats.totalReviews > 0 && (
              <div className="flex items-center gap-1 mb-1">
                <span className="text-yellow-400 text-xs">⭐</span>
                <span className="text-xs text-gray-600">
                  {reviewStats.averageRating.toFixed(1)} ({reviewStats.totalReviews})
                </span>
              </div>
            )}
            
            {/* จำนวนคงเหลือ */}
            {product.quantity !== undefined && (
              <p className="text-xs text-gray-500">
                {product.quantity > 0 ? `เหลือ ${product.quantity} ${product.unit || 'ชิ้น'}` : t('marketplace.outOfStock')}
              </p>
            )}
          </div>
        </div>
      </div>
    </Link>
  );
};

export default ProductListCard;




